import { setTrafficId } from "@redux";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

export const PageClientLink = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        // set traffice source to store, inorder to use that id on header call
        dispatch(setTrafficId(""));
    }, ["clear existing traffic id"]);
    return <></>;
};
